export const OUTWARD_CODE_LENGTH = 4;
export const INWARD_CODE_LENGTH = 3;
export const POSTCODE_LENGTH = OUTWARD_CODE_LENGTH + INWARD_CODE_LENGTH;
